import { AiHubPageUnstyled } from '@office-start/ai-hub-page-component';
import { logModuleLoadDuration } from '@office-start/ai-hub-telemetry-service';
import { useLogPageView } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var componentName = 'BizChatNative';
var BizChatNativeLazyBoundary = lazy(function () {
    var loadPromise = import(
    /* webpackChunkName: "biz-chat-native" */ '@office-start/biz-chat-native');
    return logModuleLoadDuration(loadPromise, componentName);
});
export var BizChatNativePage = function () {
    return (React.createElement(AiHubPageUnstyled, { useLogPageViewHook: useLogPageView, name: "BizChat", LazyComponent: BizChatNativeLazyBoundary, componentName: componentName }));
};
//# sourceMappingURL=BizChatNativePage.js.map